import { Card } from '../atoms'
import { ReactNode } from 'react'

export interface FeatureCardProps {
  title: string
  icon?: ReactNode
  children: ReactNode
  className?: string
}

export const FeatureCard = ({
  title,
  icon,
  children,
  className = '',
}: FeatureCardProps) => {
  return (
    <Card className={`${className}`}>
      <div className="flex items-center gap-2 mb-2.5 sm:mb-3">
        {icon && <div className="text-primary flex-shrink-0">{icon}</div>}
        <h3 className="font-semibold text-sm sm:text-base">{title}</h3>
      </div>
      {children}
    </Card>
  )
}
